(() => {
  const AUTOSCROLL_DELAY = 2600;
  const initialized = new WeakSet();
  const endedHandlers = new WeakMap();

  function pauseInactiveMedia(activeSlide) {
    document.querySelectorAll('media-gallery slideshow-slide deferred-media').forEach((media) => {
      if (activeSlide.contains(media)) return;
      if (typeof media.pauseMedia === 'function') media.pauseMedia();
    });
  }

  function playSlideVideo(slideshow, slide) {
    pauseInactiveMedia(slide);

    const deferredMedia = slide.querySelector('deferred-media');
    if (!deferredMedia) return;

    if (typeof deferredMedia.loadContent === 'function') {
      deferredMedia.loadContent(false);
    }

    window.setTimeout(() => {
      const video = deferredMedia.querySelector('video');
      if (!video || slide.getAttribute('aria-hidden') === 'true' || deferredMedia.dataset.userPaused === 'true') return;

      video.muted = true;
      video.playsInline = true;

      const existingHandler = endedHandlers.get(video);
      if (existingHandler) video.removeEventListener('ended', existingHandler);

      const handleEnded = () => {
        window.setTimeout(() => {
          if (typeof slideshow.next === 'function') slideshow.next();
        }, 450);
      };

      endedHandlers.set(video, handleEnded);
      video.addEventListener('ended', handleEnded, { once: true });

      if (typeof deferredMedia.playMedia === 'function') {
        deferredMedia.playMedia();
      } else {
        video.play().catch(() => {});
      }
    }, 500);
  }

  function initGallery(gallery) {
    if (!document.querySelector('.stickit-pdp-meta')) return;
    if (initialized.has(gallery)) return;

    const slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;

    initialized.add(gallery);

    let userInteracted = false;
    let introTimer;
    let playTimer;

    const markInteracted = (event) => {
      const controlClick = event.target.closest('slideshow-controls, slideshow-arrows, .deferred-media__poster-button');
      if (controlClick || event.type === 'pointerdown') {
        userInteracted = true;
        window.clearTimeout(introTimer);
      }

      const toggleButton = event.target.closest('.video-interaction-hint');
      const deferredMedia = toggleButton?.closest('deferred-media');
      if (deferredMedia) {
        window.clearTimeout(playTimer);
        if (deferredMedia.isPlaying) {
          deferredMedia.dataset.userPaused = 'true';
        } else {
          delete deferredMedia.dataset.userPaused;
        }
      }
    };

    gallery.addEventListener('click', markInteracted, { capture: true });
    gallery.addEventListener('pointerdown', markInteracted, { capture: true });

    gallery.addEventListener('slideshow:select', (event) => {
      if (!event.detail?.slide) return;
      window.clearTimeout(playTimer);
      playTimer = window.setTimeout(() => playSlideVideo(slideshow, event.detail.slide), 250);
    });

    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    const firstVideoIndex = slides.findIndex((slide) => slide.querySelector('deferred-media'));

    const startIntro = () => {
      if (firstVideoIndex < 0 || userInteracted) return;

      const currentSlide = slides[slideshow.current || 0];
      if (currentSlide?.querySelector('deferred-media')) {
        playSlideVideo(slideshow, currentSlide);
        return;
      }

      introTimer = window.setTimeout(() => {
        if (userInteracted || typeof slideshow.next !== 'function') return;

        let stepsRemaining = firstVideoIndex - (slideshow.current || 0);
        const advanceOne = () => {
          if (userInteracted || stepsRemaining <= 0) return;
          slideshow.next(undefined, { animate: true });
          stepsRemaining -= 1;
          if (stepsRemaining > 0) window.setTimeout(advanceOne, 900);
        };

        advanceOne();
      }, AUTOSCROLL_DELAY);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return;
          observer.disconnect();
          startIntro();
        },
        { threshold: 0.45 }
      );
      observer.observe(gallery);
    } else {
      startIntro();
    }
  }

  async function init() {
    await customElements.whenDefined('slideshow-component');
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
